// extracted by mini-css-extract-plugin
export default {"titleBar":"TitleBar_titleBar__1-dFZ","btnBack":"TitleBar_btnBack__1jnSn","btnInfo":"TitleBar_btnInfo__zTJtR"};